import {FormControl} from '@angular/forms';
import {LIST_DATE_FORMAT_NO2} from 'app/core/models/common-types';
import {format} from 'date-fns';

/* eslint-disable @typescript-eslint/naming-convention */
const REGEX_TYPES = {
  ALL: /.+/,
  EMAIL:
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  LETTERS_ONLY: /^[a-zA-Z]+$/,
  NUMBERS_ONLY: /^[0-9]+$/,
  INT_ONLY: /^\d+$/,
  FLOAT_ONLY: /^-?\d*(\.\d+)?$/,
  // PHONE_NUMBER: /^\d{3}-\d{3}-\d{4}$/,
  // PHONE_NUMBER_NO_DASH: /^\d{3}\d{3}\d{4}$/,
  // PHONE_NUMBER_PAREN: /^\d\({3}\) \d{3}-\d{4}$/,
  PHONE: /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/,
  SECTION_TOWNSHIP_RANGE: /^\d{2}-\d{3}[NS]-\d{3}[EW]$/,
};

export default REGEX_TYPES;

export function removeAllSpaces(str, toLower: boolean): string {
  if (toLower) {
    return str.replace(/\s+/g, '').toLowerCase();
  }
  return str.replace(/\s+/g, '');
}
export function getTimeStampString(): string {
  return format(new Date(), LIST_DATE_FORMAT_NO2).toUpperCase().replace(/\D/g, '');
}

export function validatePhoneInput(phoneControl: FormControl) {
  return REGEX_TYPES.PHONE.test(phoneControl.value)
    ? // REGEX_TYPES.PHONE_NUMBER_NO_DASH.test(phoneControl.value) ||
      // REGEX_TYPES.PHONE_NUMBER_PAREN.test(phoneControl.value) ||
      //   REGEX_TYPES.PHONE.test(phoneControl.value)
      null
    : {
        validateInput: {
          valid: false,
        },
      };
}
export function validatePhoneNumber(elementValue) {
  const phoneNumberPattern = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
  return phoneNumberPattern.test(elementValue);
}

export function isValidEmailAddress(elementValue) {
  const pattern = REGEX_TYPES.EMAIL;
  return pattern.test(elementValue);
}

export function formatPhoneNumber(phoneNumber: string) {
  // Filter only numbers from the input
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  // Check if the input is of correct length
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }

  return null;
}
